import { AuthProvider } from '@quartermaster/qmlib-api/dist/types/Signup';

export const TOGGLE_DEV_TOOLS = 'TOGGLE_DEV_TOOLS';
export const MOCK_SOCIAL_URLS = 'MOCK_SOCIAL_URLS';

export interface State {
  showDevTools: boolean;
  mockedSocialURLs: Array<AuthProvider> | null;
}

interface ToggleDevToolsAction {
  type: typeof TOGGLE_DEV_TOOLS;
}

interface MockSocialAction {
  type: typeof MOCK_SOCIAL_URLS;
  payload: Array<AuthProvider> | null;
}

export const toggleDevTools = () => ({ type: TOGGLE_DEV_TOOLS });

export const handleSocialMocking = (
  values: Array<{ key: string; value: string }> | null,
): MockSocialAction => {
  if (values === null) {
    return {
      type: MOCK_SOCIAL_URLS,
      payload: null,
    };
  }
  return {
    type: MOCK_SOCIAL_URLS,
    payload: values.map(val => {
      return {
        name: val.key,
        label: val.key,
        url_pattern: val.value,
        client_id: val.key,
      } as AuthProvider;
    }),
  };
};

const initialState = { showDevTools: false, mockedSocialURLs: null };

export const selectDevTools = (state: any) => state.devTools.showDevTools;

export const reducer = (
  state = initialState,
  action: ToggleDevToolsAction | MockSocialAction,
) => {
  switch (action.type) {
    case TOGGLE_DEV_TOOLS: {
      return {
        ...state,
        showDevTools: !state.showDevTools,
      };
    }
    case MOCK_SOCIAL_URLS: {
      return {
        ...state,
        mockedSocialURLs: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
